/**
 * CMCD v2 - Response-only and timing keys.
 *
 * @public
 */
export const CMCD_RESPONSE_KEYS = [
	'cmsdd',
	'cmsds',
	'rc',
	'smrt',
	'ttfb',
	'ttfbb',
	'ttlb',
	'url',
] as const
